/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { TearsheetsRequestBuilderRequestsMetadata, type TearsheetsRequestBuilder } from './tearsheets/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/v1/organizations/{organizationId}/customers/{customerNumber}
 */
export interface WithCustomerNumberItemRequestBuilder extends BaseRequestBuilder<WithCustomerNumberItemRequestBuilder> {
    /**
     * The tearsheets property
     */
    get tearsheets(): TearsheetsRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const WithCustomerNumberItemRequestBuilderUriTemplate = "{+baseurl}/api/v1/organizations/{organizationId}/customers/{customerNumber}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithCustomerNumberItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithCustomerNumberItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    tearsheets: {
        requestsMetadata: TearsheetsRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
